import React from "react";
import { Row, Col, Typography, Button } from 'antd';

// ICONS
import { IoAlbums, IoApps, IoArrowBackCircle, IoBusiness, IoClipboard, IoCloseCircle, IoGrid, IoMap, IoPeople, IoMan, IoSettings, IoIdCard, IoCalendar, IoDocument, IoBook, IoCalculator, IoPerson, IoCard, IoInformation } from "react-icons/io5";
import { RiGraduationCapFill } from "react-icons/ri";
import { Link } from "react-router-dom";

class AgenciaMenu extends React.Component {

    state = { selected: null, title: '' }

    render = () => {

        const { onMenu } = this.props

        if (this.props.type === 'pc') {
            return (
                <Row gutter={[8,8]} justify={'center'}>
                    <Col xs={24}>
                        <Link to="agenda"><Button onClick={onMenu} type="link" shape="round" block className="menu-button"><IoCalendar className="menu-button-icon" />Agenda</Button></Link>
                    </Col>
                    <Col xs={24}>
                        <Link to="clientes"><Button onClick={onMenu} type="link" shape="round" block className="menu-button"><IoPerson className="menu-button-icon" />Clientes</Button></Link>
                    </Col>
                    <Col xs={24}>
                        <Link to="comercial"><Button onClick={onMenu} type="link" shape="round" block className="menu-button"><IoBook className="menu-button-icon" />Comercial</Button></Link>
                    </Col>
                    <Col xs={24}>
                        <Link to="financeiro"><Button onClick={onMenu} type="link" shape="round" block className="menu-button"><IoCard className="menu-button-icon" />Financeiro</Button></Link>
                    </Col>
                    <Col xs={24}>
                        <Link to="relatorio"><Button onClick={onMenu} type="link" shape="round" block className="menu-button"><IoDocument className="menu-button-icon" />Relatórios</Button></Link>
                    </Col>
                    <Col xs={24}>
                        <Link to="cadastrosgerais"><Button onClick={onMenu} type="link" shape="round" block className="menu-button"><IoGrid className="menu-button-icon" />Cadastros Gerais</Button></Link>
                    </Col>
                    <Col xs={24}>
                        <Link to="configuracoes"><Button onClick={onMenu} type="link" shape="round" block className="menu-button"><IoSettings className="menu-button-icon" />Configurações</Button></Link>
                    </Col>
                </Row>
            )
        }

        if (this.props.type === 'app') {
            return (
                <Row gutter={[16,16]} justify={'center'}>
                    <Col xs={24} style={{display: 'flex', alignItems: 'center'}}>
                        <Button key={'back'} onClick={onMenu} type="link" shape="circle" style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}><IoCloseCircle size={28} color="var(--fourth)" /></Button><Typography className="menu-text">Menu</Typography>
                    </Col>
                    <Col xs={12}>
                        <Link to="agenda"><Button onClick={onMenu} type="link" shape="round" block className="menu-button"><IoCalendar className="menu-button-icon" />Agenda</Button></Link>
                    </Col>
                    <Col xs={12}>
                        <Link to={'clientes'} onClick={onMenu}><Button type="link" shape="round" block className="menu-button"><IoPerson className="menu-button-icon" />Clientes</Button></Link>
                    </Col>
                    <Col xs={12}>
                        <Link to={'comercial'} onClick={onMenu}><Button type="link" shape="round" block className="menu-button"><IoBook className="menu-button-icon" />Comercial</Button></Link>
                    </Col>
                    <Col xs={12}>
                        <Link to={'financeiro'} onClick={onMenu}><Button type="link" shape="round" block className="menu-button"><IoCard className="menu-button-icon" />Financeiro</Button></Link>
                    </Col>
                    <Col xs={12}>
                        <Link to={'relatorio'} onClick={onMenu}><Button type="link" shape="round" block className="menu-button"><IoDocument className="menu-button-icon" />relatorio</Button></Link>
                    </Col>
                    <Col xs={12}>
                        <Link to={'cadastrosgerais'} onClick={onMenu}><Button type="link" shape="round" block className="menu-button"><IoGrid className="menu-button-icon" />Cadastros Gerais</Button></Link>
                    </Col>
                    <Col xs={12}>
                        <Link to={'configuracoes'} onClick={onMenu}><Button type="link" shape="round" block className="menu-button"><IoSettings className="menu-button-icon" />Configurações</Button></Link>
                    </Col>
                </Row>
            )
        }

    }

}

export default AgenciaMenu;